import { useCallback, useState } from 'react';

type StepDirection = 'next' | 'prev';

interface StepTransitionState {
  // Cle incrementale utilisee pour forcer un remount anime des blocs UI.
  key: number;
  direction: StepDirection;
}

interface UseStepTransitionReturn {
  direction: StepDirection;
  transitionKey: number;
  triggerNext: () => void;
  triggerPrevious: () => void;
}

export default function useStepTransition(
  initialDirection: StepDirection = 'next',
): UseStepTransitionReturn {
  // Etat minimal de transition partage entre la direction et la cle d'animation.
  const [transition, setTransition] = useState<StepTransitionState>({
    key: 0,
    direction: initialDirection,
  });

  const triggerTransition = useCallback((direction: StepDirection) => {
    // Chaque transition incremente la cle pour rejouer les animations CSS.
    setTransition((previous) => ({
      key: previous.key + 1,
      direction,
    }));
  }, []);

  const triggerNext = useCallback(() => {
    // Navigation avant.
    triggerTransition('next');
  }, [triggerTransition]);

  const triggerPrevious = useCallback(() => {
    // Navigation arriere.
    triggerTransition('prev');
  }, [triggerTransition]);

  return {
    direction: transition.direction,
    transitionKey: transition.key,
    triggerNext,
    triggerPrevious,
  };
}
